import React, { useState, useEffect, useContext } from "react";
import { Card, Spinner, Image } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import NotyfContext from "../../contexts/NotyfContext";
import clicksims from "../../assets/img/clicksims.png";
import { useWhitelabel } from "../../contexts/WhitelabelContext";
import { FaSimCard } from "react-icons/fa";

const Loader = () => {
  const size = 56;
  const { whitelabelUrl, backgroundColor } = useWhitelabel();
  const ring = Math.max(40, Math.min(96, size)); // clamp

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
        gap: "2rem",
        padding: "1rem",
      }}
    >
      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
        @media (prefers-reduced-motion: no-preference) {
          .spin { animation: spin 1.2s linear infinite; }
        }
      `}</style>

      <Image
        src={whitelabelUrl || clicksims}
        alt="Loading..."
        fluid
        style={{
          maxWidth: "280px",
          width: "100%",
          height: "auto",
          objectFit: "contain",
        }}
      />

      <div
        style={{
          position: "relative",
          width: ring,
          height: ring,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* Spinner ring */}
        <div
          className="spin"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            borderRadius: "50%",
            border: `${ring / 15}px solid ${backgroundColor}22`,
            borderTopColor: backgroundColor,
            boxShadow: `0 0 12px ${backgroundColor}44`,
          }}
        />

        {/* SIM card icon */}
        <FaSimCard
          style={{
            fontSize: ring / 1.8,
            filter: `drop-shadow(0 2px 4px ${backgroundColor}44)`,
          }}
        />
      </div>
    </div>
  );
};

export default Loader;
